import React, { useReducer } from 'react';
import { HubContext } from '../Context/context';
import formReducer from '../Reduecer/FormReducer';
import globalModalReducer from '../Reduecer/GlobalModalReducer';
import globalActivitiesReducer from '../Reduecer/GlobalActivitiesReducer';
import myActivitiesReducer from '../Reduecer/MyActivitiesReducer';
import userInfoReducer from '../Reduecer/UserInfoReducer';
import { ACITVITY_MODULE } from 'Chore/Constants';
import DashboardBasicDataReducer from '../Reduecer/DashboardBasicDataReducer'
import ActivityCategoriesReducer from '../Reduecer/ActivityCategoriesReducer';
import ManuallySentEmailReducer from '../Reduecer/ManuallySentEmailReducer';
import ReloadActivitiesReducer from '../Reduecer/ReloadActivitiesReducer';
import PendFeedbackCountReducer from '../Reduecer/pendFeedbackCountReducer';

function HubContextProvider({ children }) {
  const [formState, formDispatch] = useReducer(formReducer, { activity : ACITVITY_MODULE, isEdit : false });
  const [globalModalState, globalModalDispatch] = useReducer(globalModalReducer, { isShow: false });
  const [globalActivitiesState, globalActivitiesDispatch] = useReducer(globalActivitiesReducer, { activities: [] });
  const [myActivitiesState, myActivitiesDispatch] = useReducer(myActivitiesReducer, { activities: [] });
  const [userInfoState, userInfoDispatch] = useReducer(userInfoReducer, { userInfo: {} });
  const [dashboardBasicDataState, dashboardBasicDataStateDispatch] = useReducer(DashboardBasicDataReducer, { basicDatas: {} });
  const [manuallySentEmailState, manuallySentEmailDispatch] = useReducer(ManuallySentEmailReducer, {});
  const [activityCategoriesState, activityCategoriesDispatch] = useReducer(ActivityCategoriesReducer, { categories: [] });
  const [reloadActivitiesState, reloadActivitiesDispatch] = useReducer(ReloadActivitiesReducer, { payload: {} });
  const [pendFeedbackCountState, pendFeedbackCountDispatch] = useReducer(PendFeedbackCountReducer, { payload: 0 });

  return (
    <HubContext.Provider value={{
      formState,
      formDispatch,
      globalModalState,
      globalModalDispatch,
      globalActivitiesState,
      globalActivitiesDispatch,
      myActivitiesState,
      myActivitiesDispatch,
      userInfoState,
      userInfoDispatch,
      dashboardBasicDataState,
      dashboardBasicDataStateDispatch,
      manuallySentEmailState,
      manuallySentEmailDispatch,
      activityCategoriesState,
      activityCategoriesDispatch,
      reloadActivitiesState,
      reloadActivitiesDispatch,
      pendFeedbackCountState,
      pendFeedbackCountDispatch,
    }}>
      {children}
    </HubContext.Provider>
  );
}

export default HubContextProvider;
